(function () {
  'use strict';

  function buildGlobalBuyRow() {
    /*
     * Nur auf Produktseiten arbeiten.
     */
    const productInfo =
      document.querySelector('.product-info');

    if (!productInfo) return;


    /*
     * Falls der alte Frame Chooser bereits seine
     * eigene Buy Row gebaut hat:
     * nichts verändern.
     */
    if (
      document.querySelector('.frame-buy-row')
    ) {
      return;
    }


    /*
     * Falls der Add-on Chooser bereits seine
     * eigene Buy Row gebaut hat:
     * nichts verändern.
     */
    if (
      document.querySelector('.addon-buy-row')
    ) {
      return;
    }


    /*
     * Impact Buy Buttons.
     */
    const buyButtons =
      document.querySelector(
        '.product-info__buy-buttons buy-buttons'
      );


    /*
     * Quantity Selector.
     */
    const quantityInner =
      document.querySelector(
        '.product-info__quantity-selector'
      );


    /*
     * Kompletten Quantity-Block nehmen.
     *
     * Wichtig für Impact:
     * Bei product:rerender muss der komplette
     * Theme-Block verschoben werden.
     */
    const quantity =
      quantityInner
        ? (
            quantityInner.closest(
              '.product-info__block-item[data-block-type="quantity-selector"]'
            ) ||
            quantityInner
          )
        : null;


    if (
      !buyButtons ||
      !quantity
    ) {
      return;
    }


    /*
     * Bestehende globale Buy Row suchen.
     */
    let row =
      buyButtons.closest(
        '.global-buy-row'
      );


    /*
     * Falls nicht vorhanden:
     * neue Reihe erzeugen.
     */
    if (!row) {
      row =
        document.createElement('div');

      row.className =
        'global-buy-row';

      buyButtons.insertAdjacentElement(
        'beforebegin',
        row
      );
    }


    /*
     * Quantity links.
     */
    if (
      quantity.parentElement !== row
    ) {
      row.appendChild(quantity);
    }


    /*
     * Add-to-Cart rechts.
     */
    if (
      buyButtons.parentElement !== row
    ) {
      row.appendChild(buyButtons);
    }
  }


  /*
   * Direkt beim Laden.
   */
  function init() {
    buildGlobalBuyRow();
  }


  /*
   * Impact kann beim Variantenwechsel Teile
   * des Produktformulars neu rendern.
   */
  document.addEventListener(
    'product:rerender',
    () => {
      setTimeout(
        buildGlobalBuyRow,
        50
      );

      setTimeout(
        buildGlobalBuyRow,
        250
      );
    },
    true
  );


  /*
   * Teeinblue kann ebenfalls Inhalte
   * nachträglich injizieren.
   */
  document.addEventListener(
    'teeinblue-event-component-injected',
    () => {
      setTimeout(
        buildGlobalBuyRow,
        50
      );
    }
  );


  /*
   * Shopify Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    () => {
      setTimeout(
        buildGlobalBuyRow,
        50
      );
    }
  );


  /*
   * Fallback / Selbstheilung.
   */
  setInterval(
    buildGlobalBuyRow,
    1500
  );


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();